<template>
    <div class="elder-demand">
        <mt-header fixed title="需求信息编辑">
            <router-link :to="'/elder/'+id" slot="left">
                <mt-button icon="back">返回</mt-button>
            </router-link>
        </mt-header>
        <div class="elder-form">

            <mt-checklist title="生活需求" v-model="life_demand" :options="lifeDemandOptions"></mt-checklist>
            <mt-checklist title="家政需求" v-model="family_demand" :options="familyDemandOptions"></mt-checklist>
            <mt-checklist title="医疗需求" v-model="healthy_demand" :options="healthyDemandOptions"></mt-checklist>
            <mt-checklist title="精神需求" v-model="mind_demand" :options="mindDemandOptions"></mt-checklist>
            <mt-radio title="是否接受电话精神慰问" v-model="is_accept_phone_care" :options="isAcceptPhoneCareOptions"></mt-radio>
            <mt-field label="分析总结" placeholder="请输入分析总结" type="textarea" rows="4" v-model="demand_conclusion"></mt-field>
            <mt-field label="老年人及其家庭特殊情况说明" placeholder="请输入老年人及其家庭特殊情况说明" type="textarea" rows="4" v-model="special_demand"></mt-field>

            <div class="new-form-button">
                <mt-button size="large" type="primary" @click="updateElder">提交</mt-button>
            </div>
        </div>
    </div>
</template>
<script>

    export default{


        data(){
            return {
                openid:JSON.parse(window.localStorage.getItem('UserInfo')).openid,
                id:this.$route.params.id,

                life_demand:[],
                lifeDemandOptions:[],

                family_demand:[],
                familyDemandOptions:[],

                healthy_demand:[],
                healthyDemandOptions:[],

                mind_demand:[],
                mindDemandOptions:[],

                is_accept_phone_care:'0',
                isAcceptPhoneCareOptions:[{
                    label:'否',value:'0'
                },{
                    label:'是',value:'1'
                }],

                demand_conclusion:'',
                special_demand:''

            }
        },

        methods:{
            //mini-select

            updateElder(){

                this.$indicator.open('加载中');

                this.$axios.post("/elder/demand", {openid:this.openid,elder:this.id,life_demand:this.life_demand,family_demand:this.family_demand,healthy_demand:this.healthy_demand,mind_demand:this.mind_demand,is_accept_phone_care:this.is_accept_phone_care,demand_conclusion:this.demand_conclusion,special_demand:this.special_demand})
                    .then(data => {

                        this.$indicator.close();

                        if (data.data.code === 'OK') {

                            this.$toast('修改成功!');
                        } else {
                            this.$toast(data.data.message);
                        }
                    });
            }
        },

        created(){
            this.$axios.get('/elder/demand?openid='+this.openid+'&elder='+this.id)
                .then(data => {

                    if (data.data.code === 'OK') {

                        var life_demand_array = Array();
                        for(let i=0;i<data.data.options.life_demand.length;i++){
                            life_demand_array[i] = { label:data.data.options.life_demand[i],value:data.data.options.life_demand[i]};
                        }
                        this.lifeDemandOptions = life_demand_array;

                        var family_demand_array = Array();
                        for(let i=0;i<data.data.options.family_demand.length;i++){
                            family_demand_array[i] = { label:data.data.options.family_demand[i],value:data.data.options.family_demand[i]};
                        }
                        this.familyDemandOptions = family_demand_array;

                        var healthy_demand_array = Array();
                        for(let i=0;i<data.data.options.healthy_demand.length;i++){
                            healthy_demand_array[i] = { label:data.data.options.healthy_demand[i],value:data.data.options.healthy_demand[i]};
                        }
                        this.healthyDemandOptions = healthy_demand_array;

                        var mind_demand_array = Array();
                        for(let i=0;i<data.data.options.mind_demand.length;i++){
                            mind_demand_array[i] = { label:data.data.options.mind_demand[i],value:data.data.options.mind_demand[i]};
                        }
                        this.mindDemandOptions = mind_demand_array;

                        let demand_info = data.data.data;
                        if(demand_info!==null){
                            this.life_demand = demand_info.life_demand===null?[]:demand_info.life_demand.split(',');
                            this.family_demand = demand_info.family_demand===null?[]:demand_info.family_demand.split(',');
                            this.healthy_demand = demand_info.healthy_demand===null?[]:demand_info.healthy_demand.split(',');
                            this.mind_demand = demand_info.mind_demand===null?[]:demand_info.mind_demand.split(',');

                            this.is_accept_phone_care = demand_info.is_accept_phone_care.toString();
                            this.demand_conclusion = demand_info.demand_conclusion;
                            this.special_demand = demand_info.special_demand;
                        }


                    } else {
                        this.$toast(data.data.message);
                    }
                });
        }



    }
</script>



// WEBPACK FOOTER //
// src/pages/elder/demand.vue